export const HOLD_BUTTON_ID = 'Hold';
export const NEW_ORDER_BUTTON_ID = 'New Order';
export const REMOVE_HOLD_BUTTON_ID = 'Remove Hold';
export const RESHIP_BUTTON_ID = 'reship';
export const RESTORE_SHIPMENT_BUTTON_ID = 'Restore Shipment';
export const READY_TO_PICK_BUTTON_ID = 'Mark as Ready to Pick';
